import React from 'react'
import { t } from 'i18next';
import { getTenantInfoByKey } from '../../../../helpers/helpers';
import PermanenceTotalsDetailTableList from './PermanenceTotalsDetailTableList';
import { useState } from 'react';
import { CustomTable } from '../../../CustomTable/CustomTable';

const PermanenceTotalsDetailTable = ({ totalsReports }) => {

    const haveBuildings = getTenantInfoByKey('is_building');
    const haveAccessOpenings = getTenantInfoByKey('is_access_opening');

    const firstColumns = (haveAccessOpenings === true && haveBuildings === true) ? [
        { key: t('CODE'), columnOrder: 'opening_code', order: 'ASC', active: true },
        { key: getTenantInfoByKey('opening_name'), columnOrder: 'opening_description', order: 'ASC', active: false },

    ] : [
        { key: t('CODE'), columnOrder: 'building_code', order: 'ASC', active: true },
        { key: getTenantInfoByKey('building_name'), columnOrder: 'building_description', order: 'ASC', active: false },
    ];

    const initialStateHeaders = [
        ...((haveAccessOpenings === true || haveBuildings === true) ?
            firstColumns
            :
            []
        ),
        { key: t('NORMAL_HS_SHORT'), columnOrder: 'hs_normal', order: 'ASC', active: haveAccessOpenings === false && haveBuildings === false },
        { key: t('50%_HS_SHORT'), columnOrder: 'hs_50', order: 'ASC', active: false },
        { key: t('100%_HS_SHORT'), columnOrder: 'hs_100', order: 'ASC', active: false },
        { key: t('TOTAL_HS') },
        { key: '' }
    ]

    const [headers, setHeaders] = useState(initialStateHeaders);

    const activeHeader = headers.find((header) => header.active === true);

    const orderOpitons = {
        'opening_code': {
            ASC: (a, b) => String(a.opening_code).localeCompare(String(b.opening_code)),
            DESC: (a, b) => String(b.opening_code).localeCompare(String(a.opening_code))
        },
        'opening_description': {
            ASC: (a, b) => String(a.opening_description).localeCompare(String(b.opening_description)),
            DESC: (a, b) => String(b.opening_description).localeCompare(String(a.opening_description))
        },
        'building_code': {
            ASC: (a, b) => String(a.building_code).localeCompare(String(b.building_code)),
            DESC: (a, b) => String(b.building_code).localeCompare(String(a.building_code))
        },
        'building_description': {
            ASC: (a, b) => String(a.building_description).localeCompare(String(b.building_description)),
            DESC: (a, b) => String(b.building_description).localeCompare(String(a.building_description))
        },
        'hs_normal': {
            ASC: (a, b) => a.hs_normal - b.hs_normal,
            DESC: (a, b) => b.hs_normal - a.hs_normal
        },
        'hs_50': {
            ASC: (a, b) => a.hs_50 - b.hs_50,
            DESC: (a, b) => b.hs_50 - a.hs_50
        },
        'hs_100': {
            ASC: (a, b) => a.hs_100 - b.hs_100,
            DESC: (a, b) => b.hs_100 - a.hs_100
        },
        'hs_total': {
            ASC: (a, b) => a.hs_total - b.hs_total,
            DESC: (a, b) => b.hs_total - a.hs_total
        },
    }

    const [totalReportsState, setTotalReportsState] = useState(totalsReports.sort(orderOpitons[activeHeader.columnOrder][activeHeader.order]));

    const handleSort = (key) => {
        const newData = headers.map((header) => (
            header.columnOrder === key ?
                {
                    ...header,
                    active: true,
                    order: header.order === 'ASC' ? 'DESC' : 'ASC'
                }
                :
                {
                    ...header,
                    ...(header.columnOrder ? { active: false, order: 'ASC' } : {})
                }
        ));
        const activeHeader = newData.find((header) => header.columnOrder === key);
        setHeaders(newData);
        setTotalReportsState(totalReportsState.sort(orderOpitons[activeHeader.columnOrder][activeHeader.order]))
    }

    return (
        <div>
            <CustomTable headers={headers} onClickSort={handleSort}>
                {totalReportsState.map((totalsReport, idx) =>
                    <PermanenceTotalsDetailTableList totalsReport={totalsReport} key={idx} />
                )}
            </CustomTable>
        </div>
    )
}

export default PermanenceTotalsDetailTable